import './Why.scss';
import { Trans, useTranslation } from 'react-i18next';
import Timer from '../../../Images/Why/timer.png';
import Handshake from '../../../Images/Why/handshake.png';
import SKVIcon from '../../../Images/Why/SKV_icon.png';
import AccountingIcon from '../../../Images/Why/Accounting_icon.png';
import BankIcon from '../../../Images/Why/Bank_icon.png';
import HomeNav from '../HomeNav';
import Background, { BackgroundElement } from '../Components/Background';
import Footer from '../Components/Footer/Footer';

// Media
import SwirlyLines1 from '../../../Images/Home/swirly_lines_1.png';

export default function Why() {
  const { t } = useTranslation();
  return (
    <div className="xpektor-home">
      <div className="other-intro why-intro">
        <HomeNav />
        <div className="section intro-section">
          <h1>{t('shared.why-xpektor')}</h1>
          <p className="section-text">
            {t('why-xpektor-page.intro-section.section-text.0')}
            <br />
            <br />
            {t('why-xpektor-page.intro-section.section-text.1')}
          </p>
        </div>
      </div>
      <Background color1="#000B4F" color2="#010024">
        <div className="section-with-element">
          <div className="section">
            <div className="why-row">
              <div className="why-row-text-column">
                <h2>{t('why-xpektor-page.why-row-text-columns.0.header')}</h2>
                <p className="section-text">
                  {t('why-xpektor-page.why-row-text-columns.0.section-text')}
                </p>
              </div>
              <img src={Timer} alt="Timer" className="why-row-image" />
            </div>
          </div>
          <BackgroundElement img={SwirlyLines1} yPos={-100} />
        </div>
        <div className="section">
          <div className="why-row">
            <img src={Handshake} alt="Handshake" className="why-row-image" />
            <div className="why-row-text-column">
              <h2>{t('why-xpektor-page.why-row-text-columns.1.header')}</h2>
              <p className="section-text">
                {t('why-xpektor-page.why-row-text-columns.1.section-text')}
              </p>
            </div>
          </div>
        </div>
        <div className="section">
          <div className="why-connections-row">
            <div className="why-connection-column">
              <img
                src={AccountingIcon}
                alt="Accounting"
                className="why-column-image"
              />
              <h2>{t('why-xpektor-page.why-connections-columns.0.header')}</h2>
              <p className="section-text">
                <Trans i18nKey="why-xpektor-page.why-connections-columns.0.section-text" />
              </p>
            </div>
            <div className="why-connection-column">
              <img
                src={BankIcon}
                alt="Accounting"
                className="why-column-image"
              />
              <h2>{t('why-xpektor-page.why-connections-columns.1.header')}</h2>
              <p className="section-text">
                {t('why-xpektor-page.why-connections-columns.1.section-text')}
              </p>
            </div>
            <div className="why-connection-column">
              <img
                src={SKVIcon}
                alt="Accounting"
                className="why-column-image"
              />
              <h2>{t('why-xpektor-page.why-connections-columns.2.header')}</h2>
              <p className="section-text">
                {t('why-xpektor-page.why-connections-columns.2.section-text')}
              </p>
            </div>
          </div>
        </div>
        <Footer darkMode />
      </Background>
    </div>
  );
}
